import axios from "axios";
import React, { createContext, useEffect, useState, useContext } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false);

  //checking token login

  const checkLogin = async () => {
    const token = localStorage.getItem("tokenStore");
    if (token) {
      const verified = await axios.get("/user/verify", {
        headers: { Authorization: token },
      });
      console.log(verified);

      setIsLogin(verified.data);
      if (verified.data === false) {
        return localStorage.clear();
      }
    } else {
      setIsLogin(false);
    }
  };

  useEffect(() => {
    try {
      checkLogin();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const state = {
    isLogin: [isLogin, setIsLogin],
  };

  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
